import React, { Component } from "react";
import {
    Row,
    Col
} from "reactstrap";

import EnterpriseInformationDeliveryList from "./Information/DeliveryList";


class EnterpriseAddresses extends Component{
    constructor(props){
        super(props);

        this.onAddressAdded = this.onAddressAdded.bind(this);

        this.delivery_list = null;
    }

    onAddressAdded(){
        if(this.delivery_list)
            this.delivery_list.loadData();
    }

    render(){
        return (
            <div>
                <Row>
                    <Col xs="12" sm="12" lg="6">
                        <EnterpriseInformationDeliveryList
                            ref={ref => {this.delivery_list = ref;}}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

EnterpriseAddresses.defaultProps = {

};

export default EnterpriseAddresses;




// WEBPACK FOOTER //
// ./src/components/Enterprise/Addresses.js